module.exports = __webpack_public_path__ + "static/media/3.f9c4e067.png";